import { createSlice } from "@reduxjs/toolkit"

const provinceSlice = createSlice({
  name: "province",
  initialState: {
    listProvince: [],
  },
  reducers: {
    setListProvince: (state, action) => {
      state.listProvince = action.payload
    },
  },
})

export const { setListProvince } = provinceSlice.actions
export default provinceSlice.reducer
